export default {
  admin: "Admin",
  member: "Member",
  otherSettings: "Other Settings",
  organization: "Organization",
  primaryInteracEmailAddress: "Primary Interac Email Address",
  updateMember: "Update Member",
  deactivateMember: "Deactivate",
  reactivateMember: "Reactivate",
  changeRoleToMember: "Change Role to Member",
  changeRoleToAdmin: "Change Role to Admin",
  changeRoleToOwner: "Change Role to Owner",
  activeTeamMembers: "Active Team Members ({{count}})",
  deactivated: "Deactivated Team Members ({{count}})",
  teamMemberDeleted: "Team member deactivated",
  scheduleSettings: "Schedule Settings",
  timezone: "Timezone",
  workingDays: "Working Days",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  scheduleSettingsUpdated: "Schedule settings updated successfully",
  atLeastOneWorkingDay: "At least one working day must be selected",
  contributor: "Contributor",
  addTeamMember: "Add Team Member",
  addTeamMemberMenu: "Add Team Member Menu",
  addContributor: "Add Contributor",
  addContributorDescription:
    "Add a contributor to your team. Contributors are managed via Slack and do not need to log in.",
  editContributor: "Edit Contributor",
  deleteContributor: "Delete Contributor",
  deleteContributorConfirm:
    "This will permanently remove the contributor and all their time entries. This action cannot be undone.",
  deleteConfirmPhrase: "DELETE",
  deleteContributorTypePrompt: "Type {{phrase}} to confirm.",
  deleteContributorTypeMismatch: "The confirmation phrase does not match.",
  contributorCreatedSuccess:
    "Contributor added. They'll be matched to Slack on next sync.",
  contributorUpdatedSuccess: "Contributor updated successfully.",
  contributorDeletedSuccess: "Contributor removed successfully.",
  slackMatched: "Matched",
  slackMatchedTooltip: "This contributor is linked to a Slack account.",
  slackUnmatched: "Unmatched",
  slackUnmatchedTooltip:
    "This contributor has not been matched to a Slack account yet. They will be matched automatically on the next sync.",
  addAnother: "Add another",
  emailChangeSlackNote:
    "Changing the email may require Slack to re-sync the mapping.",
  hourlyRate: "Hourly Rate",
  editRate: "Edit Rate",
  rateUpdatedSuccess: "Rate updated successfully.",
};
